import React, { useEffect, useState, useRef } from "react";
import NoRecordsFound from "../../assets/icons/search-no-records.png"
import SkeletonLoader from "react-loading-skeleton";
import { HiMiniArrowLongUp, HiMiniArrowLongDown } from "react-icons/hi2";
import "./table.css";
// import NoRecords from "../no-records";
import { CustomButton } from "../buttons/button";
import { FaCheckCircle } from "react-icons/fa";
import DeleteIcon from "../../assets/icons/trash.png";
import CheckboxField from "../custom-fields/checkbox";

//**************************** inifinit scroll  
import InfiniteScroll from "react-infinite-scroll-component";

const Table = (props: any) => {
  const {
    defaultSort,
    defaultSortDir,
    columns,
    data,
    scopedSlots,
    Clickable,
    rowClick,
    addClassName,
    columnClassNames,
    columnColSpans,
    response,
    editIndex,
    updateStock,
    showCheckbox,
    showSelectAllCheckbox = true,
    showCheckboxCondition,
    showModalSelectedAbove = 1,
    selectedRows,
    setSelectedRows,
    sortTitleKeys, // object key, value for sorting; key = column name , value = sort key
    handleSortfunc,
    sort, // boolean value for sorting
    tableScroll,
    loading,
    StickyStart, // Boolean value for first title sticky condition
    StickyEnd, // Boolean value for last title sticky condition
    MultiDeletedFucn,
    MultiOperationButton = "Delete",
    MultiOperationButtonIcon = DeleteIcon,
    MultiOperationButtonIconComponent = null,
    MultiOperationButtonIconClass = "text-[#E72E55] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1] border-[#E72E55]",
    MultiOperationButton2 = null,
    MultiOperationButton2Func = null,
    MultiOperationButton2IconComponent = null,
    MultiOperationButton2IconClass = "bg-white hover:bg-teal-50 disabled:bg-white disabled:opacity-50 border-[#17be62] hover:border-[#14a085]",
    NextPageData,
    hasNextPage,
    tableHeight = 500,
    pageSecondTableIndentifyClass = null,
    rowSpecificClass = null,
  } = props;
  const leadObject: any = scopedSlots;
  const numberOfProperties: any = leadObject && Object.keys(leadObject).length;
  const noRecordsColSpan =
    columnColSpans?.length > 0
      ? columnColSpans.reduce((a: any, b: any) => a + b, 0)
      : Math.max(1, columns?.length || 0);
  const [sortColumn, setSortColumn] = useState<any>(defaultSort || null);
  const [sortDirection, setSortDirection] = useState<any>(defaultSortDir || null);
  const tableRef = useRef<any>(null);
  const [loadNextPage, setLoadNextPage] = useState<any>(false);

  const scrollToTop = () => {
    const container = pageSecondTableIndentifyClass ? document.querySelector(`.${pageSecondTableIndentifyClass}`) : document.querySelector('.InfiniteScrollClass');
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  const handleSort = (column: any) => {
    let direction = "asc";
    if (column === sortColumn) {
      direction = sortDirection === "asc" ? "desc" : "asc";
    }
    scrollToTop()
    setSortColumn(column);
    setSortDirection(direction);
    const sort_key = sortTitleKeys?.[column] ? sortTitleKeys?.[column] : "";
    data?.length > 1 && handleSortfunc && handleSortfunc(sort_key, direction);
  };
  const [selectAll, setSelectAll] = useState(false);

  // useEffect(() => {
  //   // Update selectAll state when all rows are selected
  //   const allRowsSelected =
  //     data?.length > 0 &&
  //     data?.every(
  //       (row: any) =>
  //         selectedRows?.find(
  //           (selectedRow: any) => selectedRow?.id === row?.id
  //         )?.id
  //     );
  //   setSelectAll(allRowsSelected);
  // }, [selectedRows, data]);

  useEffect(() => {
    const selectableRows = Array.isArray(data)
      ? data.filter(
        (row: any) =>
          showCheckboxCondition == null || showCheckboxCondition(row)
      )
      : [];
    const allRowsSelected =
      selectableRows.length > 0 &&
      selectableRows.every((row: any) =>
        selectedRows?.some((selectedRow: any) => selectedRow?.id === row?.id)
      );

    setSelectAll(allRowsSelected);
  }, [selectedRows, data]);


  useEffect(() => {
    setLoadNextPage(false)
  }, [data]);

  useEffect(() => {
    if (loading) {
      const scrollElement = document.querySelector('.InfiniteScrollClass');
      if (scrollElement) {
        scrollElement.scrollTop = 0;
      }
      scrollToTop()
    }
  }, [loading]);

  const checkBoxRowSelection = (row: any) => {
    if (selectedRows?.includes(row)) {
      setSelectedRows(
        selectedRows.filter((selectedRow: any) => selectedRow !== row)
      );
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };
  const checkBoxSelectAll = () => {
    setSelectAll(!selectAll);
    setSelectedRows((prev: any) => {
      if (selectAll) {
        const selectedAll = [...prev]?.filter(
          (row: any) =>
            data?.find((selectedRow: any) => selectedRow?.id === row?.id)
              ?.id !== row?.id
        );
        return [...selectedAll];
      } else {
        return [
          ...prev,
          ...(data ?? []).filter(
            (row: any) =>
              !(prev?.find((selectedRow: any) => selectedRow?.id === row?.id)) &&
              (showCheckboxCondition == null || showCheckboxCondition(row))
          ),
        ];
      }
    });
  };

  const isRowSelected = (row: any) =>
    selectedRows?.find((data: any) => data?.id === row?.id)?.id
      ? true
      : false;
  const sortIcon = (column: any) => {
    return sortTitleKeys?.[column] ? true : false;
  };

  const loadnextPage = () => {
    if (!loading) {
      setLoadNextPage(true)
      NextPageData()
    }
  }


  return (
    <div
      className={response ? `table-responsive-2 w-full p-0` : `table-responsive w-full p-0 `}
      ref={tableRef} id="scrollableDiv"
    >
      <InfiniteScroll
        dataLength={data?.length ? data?.length : 0}
        next={loadnextPage}
        hasMore={hasNextPage ? hasNextPage : false}
        endMessage={data?.length > 12 ? <p className="text-center"></p> : null}
        loader={''}
        height={tableHeight}
        scrollableTarget="scrollableDiv"
        className={`InfiniteScrollClass w-full min-w-0 ${pageSecondTableIndentifyClass ? pageSecondTableIndentifyClass : ''}`}
      >

        <table
          className={`table table-bordered rounder-lg w-full min-w-full ${addClassName}`}
          style={{
            width: tableScroll ? tableScroll : "100%",
            cursor: Clickable ? "pointer" : "default",
          }}
        >
          <thead className="sticky top-0 z-9 bg-[#E8EAEA]">
            <tr className="sticky top-0">
              {showCheckbox && data?.length > 0 && (
                <th
                  key="checkbox"
                  className={`text-center pt-1 pl-2 ${StickyStart && "checkbox_sticky"
                    }`}
                >
                  <div className="ms-1">
                    {showSelectAllCheckbox &&
                    <CheckboxField
                      divStyle={"justify-center"}
                      checked={selectAll}
                      onChange={checkBoxSelectAll}
                      labelStyle="text-[#1C0F03]"
                      checkboxStyle="w-[1.1rem] h-[1.1rem] "
                    />}
                    {/* <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={checkBoxSelectAll}
                  /> */}
                  </div>
                </th>
              )}
              {columns.map((column: any, index: number) =>
                column === "Action" || column === "Actions" ? (
                  <th
                    key={column}
                    style={{ fontWeight: "bold" }}
                    onClick={(e) => {
                      e.stopPropagation()
                    }}
                    className={`text-center pl-[12px]  px-3  py-[13px] text-[12px] font-[600] cursor-default
                                        ${columnClassNames?.length > 0
                        ? columnClassNames?.[index]
                        : ""
                      }
                                         ${StickyEnd &&
                        index === columns?.length - 1
                        ? "sticky_title_end"
                        : ""
                      } `}
                    colSpan={
                      columnColSpans?.length > 0 ? columnColSpans[index] : 1
                    }
                  >
                    {column}
                  </th>
                ) : (
                  <th
                    style={{ fontWeight: "bold" }}
                    key={column}
                    onClick={() =>
                      sort ? (sortIcon(column) ? handleSort(column) : null) : null
                    }
                    className={`text-center px-[12px] py-[13px] text-[12px] font-[600] ${sortIcon(column) ? "cursor-pointer" : "cursor-default"
                      }
                                        ${columnClassNames?.length > 0
                        ? columnClassNames?.[index]
                        : ""
                      }  ${StickyStart && index === 0
                        ? showCheckbox
                          ? "sticky_title_checkbox"
                          : "sticky_title_start"
                        : ""
                      }`}
                    colSpan={
                      columnColSpans?.length > 0 ? columnColSpans[index] : 1
                    }
                  >
                    <div className={`flex justify-cente items-  `}>
                      <div className="flex items-center">
                        <span>{column}</span>
                        {sort && (
                          <span
                            className={`mr-2 ${sortIcon(column) ? "flex items-center" : "hidden"
                              }`}
                          >
                            <span className="relative flex">
                              <HiMiniArrowLongUp
                                size={14}
                                style={{
                                  color:
                                    sortColumn === column &&
                                      sortDirection === "asc"
                                      ? "#0F337C"
                                      : "",
                                }}
                              />

                              <HiMiniArrowLongDown
                                size={14}
                                className="relative "
                                style={{
                                  color:
                                    sortColumn === column &&
                                      sortDirection === "desc"
                                      ? "#0F337C"
                                      : "",
                                  left: "-7px",
                                }}
                              />
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody className="scrollable-tbody" >
            {loading ? (
              Array(10)
                ?.fill(0)
                ?.map((_, i) => (
                  <tr key={i}>
                    {showCheckbox && data?.length > 0 && (
                      <td className="text-center">
                        <SkeletonLoader width={20} height={25} />
                      </td>
                    )}
                    {columns.map((column: any, j: number) => (
                      <td
                        key={j}
                        colSpan={
                          columnColSpans?.length > 0 ? columnColSpans[j] : 1
                        }
                      >
                        <SkeletonLoader width="100%" height={25} />
                      </td>
                    ))}
                  </tr>
                ))
            ) : data?.length > 0 ? (
              data?.map((row: any, index: number) => (
                <>
                  <tr
                    key={row?.id}
                    style={{ cursor: Clickable ? "pointer" : "default" }}
                    onClick={(e) => {
                      if (Clickable) {
                        e?.stopPropagation();
                        Clickable && rowClick(row);
                      }
                    }}
                    className={`hover:bg-gray-100 ${rowSpecificClass ? rowSpecificClass(row) : ''}`}
                  >
                    {showCheckbox && data?.length > 0 && (
                      <td
                        style={{ cursor: Clickable ? "pointer" : "default" }}
                        className={`text-center ${StickyStart && "checkbox_sticky"
                          }`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="">
                          {(showCheckboxCondition == null || showCheckboxCondition(row)) &&
                            <CheckboxField
                              divStyle="checkbox_div justify-center"
                              checked={isRowSelected(row)}
                              onChange={(e: any) => {
                                e.stopPropagation(); // Prevent event bubbling
                                checkBoxRowSelection(row);
                              }}
                              labelStyle="text-[#1C0F03]"
                              checkboxStyle="w-[1.1rem] h-[1.1rem] "
                            />
                          }
                        </div>
                      </td>
                    )}
                    {columns.map((column: any, colIndex: any) => {
                      return column === "Action" ||
                        column === "Actions" ||
                        scopedSlots[column]({ row, key: column, index }) ? (
                        scopedSlots[column]({ row, key: column, index })
                      ) : (
                        <td
                          style={{ cursor: Clickable ? "pointer" : "default" }}
                          className={`px-3`}
                          // role="none"
                          key={column}
                          colSpan={
                            columnColSpans?.length > 0
                              ? columnColSpans[colIndex]
                              : 1
                          }
                          onClick={(e) => {
                            if (Clickable) {
                              e.stopPropagation();
                            }
                          }}
                        >
                          <div
                            className="inline"
                            style={{ cursor: Clickable ? "pointer" : "default" }}
                          >
                            {row[column.toLowerCase()]
                              ? row[column.toLowerCase()]
                              : row[column] || "-"}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                  {editIndex === index ? updateStock : null}
                </>
              ))
            ) : (
              <tr className="not_found_section cursor-default">
                <td
                  colSpan={noRecordsColSpan}
                >
                  <div
                    className="not_found flex justify-center items-center "
                    style={{ height: "26rem" }}
                  >
                    <div className="text-center">
                      <img
                        src={NoRecordsFound}
                        alt="not found"
                        className="w-full h-full"
                      />
                      <span className="text-center text-[26px]">No Results Found</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}
            {data?.length > 0 && loadNextPage && (
              <>
                <tr>
                  {showCheckbox && data?.length > 0 && (
                    <td className="text-center">
                      <SkeletonLoader width={20} height={40} />
                    </td>
                  )}
                  {columns.map((column: any, j: number) => (
                    <td
                      key={j}
                      colSpan={
                        columnColSpans?.length > 0 ? columnColSpans[j] : 1
                      }
                    >
                      <SkeletonLoader width="100%" height={40} />
                    </td>
                  ))}
                </tr>
              </>
            )}
          </tbody>
        </table>



      </InfiniteScroll>

      {
        selectedRows?.length > showModalSelectedAbove && (
          <div
            className="fixed bottom-[100px] left-0 right-0 bg-[#FFFFFF] max-w-fit mx-auto p-[12px] rounded-[8px] z-50 flex justify-center border border-[#EEEFF2] "
            style={{
              boxShadow: "0px 4px 20px 0px #272B301F",
              backdropFilter: "blur(20px)",
            }}
          >
            <div className="flex items-center gap-[10px] flex-nowrap">
              <span className="text-[#031227] text-[14px] font-medium leading-[17px] flex items-center gap-[4px]">
                <FaCheckCircle size={14} color="#308B7E" /> {selectedRows?.length}{" "}
                Selected
              </span>
              {showSelectAllCheckbox &&
              <CustomButton
                buttonStyle="text-[#031227] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1]  px-[12px] py-[10px] text-[14px] font-semibold leading-[17px] border-[#E8ECF4] "
                buttonName="Select all"
                primary={false}
                disable={
                  selectedRows?.length ===
                  (Array.isArray(data)
                    ? data.filter(
                      (row: any) =>
                        showCheckboxCondition == null || showCheckboxCondition(row)
                    )
                    : []
                  ).length
                }

                onClick={() => {
                  setSelectedRows(
                    (data ?? []).filter(
                      (row: any) =>
                        showCheckboxCondition == null || showCheckboxCondition(row)
                    )
                  );
                }}
              />}
              <CustomButton
                buttonStyle="text-[#031227] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1]  px-[12px] py-[10px] text-[14px] font-semibold leading-[17px] border-[#E8ECF4] "
                buttonName="Unselect all"
                primary={false}
                disable={selectedRows?.length === 0}
                onClick={() => {
                  setSelectedRows([]);
                }}
              />
              <div className="w-[1px] h-full bg-[#EEEFF2]" />
              <CustomButton
                buttonStyle={`px-[12px] py-[10px] text-[14px] font-semibold leading-[17px]  ${MultiOperationButtonIconClass}`}
                buttonName={MultiOperationButton}
                isFront={true}
                iconStyle="mr-[8px]"
                icon={ MultiOperationButtonIconComponent || <img
                    src={MultiOperationButtonIcon}
                    alt="Delete"
                    className="cursor-pointer  w-[18px] h-[18px] text-red-500"
                  />
                }
                primary={false}
                onClick={MultiDeletedFucn}
              />
              {MultiOperationButton2 && MultiOperationButton2Func && (
                <CustomButton
                  buttonStyle={`px-[12px] py-[10px] text-[14px] font-semibold leading-[17px]  ${MultiOperationButton2IconClass}`}
                  buttonName={MultiOperationButton2}
                  isFront={true}
                  iconStyle="mr-[8px]"
                  icon={MultiOperationButton2IconComponent}
                  primary={false}
                  onClick={MultiOperationButton2Func}
                />
              )}
            </div>
          </div>
        )
      }
    </div >
  );
};

export default Table;